export const stEventBuffer = [];
export function addToBuffer(evt) {
  if (!evt) return;
  stEventBuffer.push(evt);
}
export function clearStEventBuffer() {
  stEventBuffer.length = 0;
}
export function getBufferSnapshot() {
  return stEventBuffer.slice();
}
